/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalFilterDelete
 */
export interface GlobalFilterDelete {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterDelete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterDelete
     */
    deleted?: boolean;
}

export function GlobalFilterDeleteFromJSON(json: any): GlobalFilterDelete {
    return GlobalFilterDeleteFromJSONTyped(json, false);
}

export function GlobalFilterDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterDelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function GlobalFilterDeleteToJSON(value?: GlobalFilterDelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


